export const FEATURE_NAME = 'cantons';

export const FULL_NAME = 'fullname';
export const TOTAL = 'totalPopulation';
export const DEMENTIA = 'dementiaPopulations';
